import { useMemo, type FC, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";

import { MultiChoiceRadio } from "components/Shared";

import "./ChooseYesNo.scss";

export interface ChooseYesNoProps {
    label: ReactNode;
    name: string;
    value?: boolean | null;
    onChange: (value: boolean | null) => void;
    required?: boolean;
    error?: boolean;
    helperText?: ReactNode;
}

export const ChooseYesNo: FC<ChooseYesNoProps> = ({ label, name, value, onChange, required, error, helperText }) => {
    const { t, ready: translationsReady } = useTranslation('common', { useSuspense: false });

    const options = useMemo(() => [
        { value: 'true', label: t('yes') },
        { value: 'false', label: t('no') },
    ], [t, translationsReady]);

    return translationsReady && (
        <FormControl fullWidth error={error} className="ms-choose-yes-no">
            <FormControlLabel
                label={<strong>{label}</strong>}
                labelPlacement="top"
                required={required}
                control={
                    <MultiChoiceRadio
                        value={value === null ? null : String(value)}
                        onChange={(newValue) => onChange(newValue === null ? null : (newValue === 'true'))}
                        name={name}
                        options={options}
                    />
                }
            />
            <FormHelperText>{helperText || ''}</FormHelperText>
        </FormControl>
    );
};
